import React from "react";
import { Pagination as MantinePagination, Group } from "@mantine/core";
import styles from "./styles.module.css";
import Text from "@/components/atoms/Text";
import Select from "@/components/atoms/Select";

interface PaginationProps {
  totalItems: number;
  rowsPerPage: number;
  activePage: number;
  onRowsPerPageChange: (value: string | null) => void;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = (props) => {
  const { totalItems, rowsPerPage, onRowsPerPageChange, onPageChange, activePage } = props;

  const totalPages = Math.ceil(totalItems / rowsPerPage);
  const startItem = (activePage - 1) * rowsPerPage + 1;
  const endItem = Math.min(activePage * rowsPerPage, totalItems);

  return (
    <Group justify="flex-end" mt="10">
      <Select
        data-testid="contracts-rows-per-page-select"
        className={styles.paginationSelect}
        label=""
        data={["15", "30", "50", "100"]}
        value={String(rowsPerPage)}
        onChange={onRowsPerPageChange}
      />

      <Text data-testid="contracts-pagination-range">
        {totalItems > 0 ? startItem : 0}-{endItem} av {totalItems}
      </Text>
      <MantinePagination
        total={totalPages}
        value={activePage}
        onChange={onPageChange}
        withPages={false}
        getControlProps={(control) => ({ "data-testid": `contracts-pagination-${control}` })}
      />
    </Group>
  );
};

export default Pagination;
